import React, { ReactNode } from 'react';

import InputCounter from '../InputCounter/InputCounter';
import FormInputAdditionalDescription from './Partials/FormInputAdditionalDescription';

type FormFieldWrapperType = {
  maxLength?: number;
  currentCount: number;
  showAdditionalDescription?: boolean;
  additionalDescription?: string;
  describedById?: string;
  children: string | ReactNode;
};

/**
 * Wrapping component for <input> and <textarea>
 * to enable proper rendering of character counter.
 * If there is no maxLength sent to it as property,
 * it doesn't render the counter.
 */
export default function FormFieldWrapper({
  maxLength = undefined,
  currentCount,
  showAdditionalDescription = false,
  additionalDescription,
  describedById,
  children,
}: FormFieldWrapperType) {
  return (
    <span className="form-field-wrapper">
      {children}
      <span className="form-field-wrapper__sibling">
        {maxLength && <InputCounter maxLength={maxLength} currentCount={currentCount} />}
        {showAdditionalDescription && additionalDescription && describedById && (
          <FormInputAdditionalDescription id={describedById} additionalDescription={additionalDescription} />
        )}
      </span>
    </span>
  );
}
